import { html } from "lit";
import { styles } from "./styles";
import myPhoto from "../../assets/me_v2.jpg";
import { skillsData } from "../../data/skills";
import cvPdf from "../../assets/Justyna_Lodzinska_CV.pdf";
import { BasicApp } from "../../layout/basicApp";
import { translate } from "lit-translate";
import codeImg from "../../assets/code.png";
import styleImg from "../../assets/style.png";
import toolsImg from "../../assets/tools.png";

class SkillsTab extends BasicApp {
  constructor() {
    super()
    this.anything = false

    const startYear = 2020;
    const startMonth = 8;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    let experienceYears = currentYear - startYear;
    let experienceMonths = currentMonth - startMonth;

    if (experienceMonths < 0) {
      experienceYears--;
      experienceMonths += 12;
    }

    this.experienceY = experienceYears;
    this.experienceM = experienceMonths;
  }

  static get styles() {
    return [styles]
  }

  createRenderRoot() {
    return this;
  }

  animateText() {
    var text = document.getElementById('text');
    var newDom = '';
    var animationDelay = 2;

    for (let i = 0; i < text.innerText.length; i++) {
      newDom += '<span class="char">' + (text.innerText[i] == ' ' ? '&nbsp;' : text.innerText[i]) + '</span>';
    }

    text.innerHTML = newDom;
    var length = text.children.length;

    for (let i = 0; i < length; i++) {
      text.children[i].style['animation-delay'] = animationDelay * i + 'ms';
    }
  }

  firstUpdated(_changedProperties) {
    const textAvailable = document.querySelector("#text")
    super.firstUpdated(_changedProperties);
    // if (textAvailable) this.animateText()
  }

  updateUrl(url) {
    console.log(url)
    window.location.hash = url;
  }

  render() {
    this.anything = true
    return html`
        <div class="outer skills-page">
            <h1 class="page-ttl">${translate("skills.about.title")}</h1>
            <div class="skills-page__about">
                <div class="skills-page__about__description">
                    <div style="color: #333">
                        <p id="text">${translate("skills.about.details")}</p>
                    </div>
                    <div class="skills__general-info">
                        <div><span>${translate("skills.about.name")}</span>Justyna Łodzińska</div>
                        <div>
                            <span>${translate("skills.about.experience")}</span>
                            ${this.experienceY} ${translate("skills.about.experienceYears")}
                            ${this.experienceM > 0 ? this.experienceM : ''}
                            ${this.experienceM > 0 ? translate("skills.about.experienceMonths") : ''}
                        </div>
                        <div><span>${translate("skills.about.phone")}</span>(+48) 787-904-357</div>
                        <div><span>${translate("skills.about.email")}</span>justyna.lodzinska13@gmail.com</div>
                        <div>
                            <span>${translate("skills.about.location")}</span>${translate("skills.about.locationValue")}
                        </div>
                    </div>
                    <div class="skills-page__btns">
                        <button class="uk-button uk-button-primary btn btn--main"
                                @click="${() => this.updateUrl('contact')}">
                            ${translate("skills.about.buttons.contactMe")}
                        </button>
                        <a class="uk-button uk-button-default btn btn--outlined" href="${cvPdf}"
                           download="cv-justyna-lodzinska.pdf">
                            ${translate("skills.about.buttons.downloadCV")}</a>
                    </div>
                </div>
                <div class="skills-page__about__photo">
                    <img src="${myPhoto}" alt="My photo">
                </div>
            </div>
            <h2 class="page-ttl">${translate("skills.tech-stack.title")}</h2>
            <div>
                <p>${translate("skills.tech-stack.details")}</p>
                 <table>
                  <thead>
                      <th>
                          <img src="${codeImg}" alt="code" width="20" height="20" style="margin-right: 6px; margin-top: -1px;">
                          ${translate("skills.table.colLanguages")}
                      </th>
                      <th>
                          <img src="${styleImg}" alt="code" width="20" height="20" style="margin-right: 6px; margin-top: -1px;">
                          ${translate("skills.table.colStyles")}
                      </th>
                      <th>
                          <img src="${toolsImg}" alt="code" width="20" height="20" style="margin-right: 6px; margin-top: -1px;">
                          ${translate("skills.table.colTools")}
                      </th>
                  </thead>
                  <tbody>
                      <td data-column="${translate("skills.table.colLanguages")}">
                          <ul>
                              ${skillsData.languages.map(skill => {
                                return html`<li>${skill}</li>`
                              })}
                          </ul>
                      </td>
                      <td data-column="${translate("skills.table.colStyles")}">
                          <ul>
                              ${skillsData.styles.map(skill => {
                                return html`<li>${skill}</li>`
                              })}
                          </ul>
                      </td>
                      <td data-column="${translate("skills.table.colTools")}">
                          <ul>
                              ${skillsData.tools.map(skill => {
                                  return html`<li>${skill}</li>`
                                })}
                          </ul>
                      </td>
                  </tbody>
              </table>
            </div>
        </div>
    `;
  }
}

customElements.define('skills-tab', SkillsTab);
